module.exports = __webpack_public_path__ + "static/media/sprint-logo.683123ff.png";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/assets/resources/sprint-logo.png
// module id = 2669
// module chunks = 0